<template class="main-container">
  <v-container class="" max-width="1000">
    <v-row class="elevation-4">
      <v-col cols="auto" class="flex-grow-1 flex-shrink-0">
        <v-responsive v-if="activeChat">
          <v-card flat class="d-flex flex-column">
            <v-card-title>
              <a :href="'/user/' + username">{{ name }}</a>
            </v-card-title>
            <hr />
            <v-card-text style="height: calc(100vh - 300px); overflow-y: scroll" id="container">
              <template v-for="(msg, i) in messages" style="height: 800px; overflow-y: scroll">
                <div :class="{ 'd-flex flex-row-reverse': me(msg) }" :key="i">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-hover v-slot:default="{ hover }">
                        <div>
                          <v-badge
                            v-if="msg.new"
                            bordered
                            bottom
                            color="deep-purple accent-4"
                            dot
                            offset-x="10"
                            offset-y="10"
                          >
                            <v-chip
                              :color="me(msg) ? 'primary' : ''"
                              dark
                              style="height: auto; white-space: normal"
                              class="pa-4 mb-2"
                              v-on="on"
                            >
                              <v-img
                                v-if="fileKind(msg) === 'image'"
                                :src="msg.thumbnailUrl"
                                style="max-width: 180px"
                                @click.stop="loadImage(msg.fileUuid)"
                              />
                              <div v-else-if="msg.fileUuid" class="chat-file-chip" @click.stop="openFile(msg)">
                                <v-icon left>{{ fileIcon(msg) }}</v-icon>
                                <span class="chat-file-name">{{ msg.fileName || 'File' }}</span>
                              </div>
                              {{ msg.text }}
                              <sub class="ml-2" style="font-size: 0.5rem">{{ formatDate(msg.createdAt) }}</sub>
                              <v-icon v-if="hover" small> mdi-expand_more </v-icon>
                            </v-chip>
                          </v-badge>
                          <v-chip
                            v-if="!msg.new"
                            :color="me(msg) ? 'primary' : ''"
                            dark
                            style="height: auto; white-space: normal"
                            class="pa-4 mb-2"
                            v-on="on"
                          >
                            <v-img
                              v-if="fileKind(msg) === 'image'"
                              :src="msg.thumbnailUrl"
                              style="max-width: 180px"
                              @click.stop="loadImage(msg.fileUuid)"
                            />
                            <div v-else-if="msg.fileUuid" class="chat-file-chip" @click.stop="openFile(msg)">
                              <v-icon left>{{ fileIcon(msg) }}</v-icon>
                              <span class="chat-file-name">{{ msg.fileName || 'File' }}</span>
                            </div>
                            {{ msg.text }}
                            <sub class="ml-2" style="font-size: 0.5rem">{{ formatDate(msg.createdAt) }}</sub>
                            <v-icon v-if="hover" small> mdi-expand_more </v-icon>
                          </v-chip>
                        </div>
                      </v-hover>
                    </template>
                    <v-list v-if="me(msg)">
                      <v-list-item @click="deleteMessageOrBlockUser(msg)">
                        <v-list-item-title>{{ me(msg) ? 'Delete message' : 'Block user' }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </template>
              <v-alert v-if="error" type="error">
                {{ error }}
              </v-alert>
            </v-card-text>
            <v-card-text class="flex-shrink-1">
              <v-text-field
                v-model="message"
                label="message"
                type="text"
                no-details
                outlined
                append-icon="mdi-send"
                @keyup.enter="sendMessage()"
                @click:append="sendMessage()"
                hide-details
              >
                <template v-slot:append-outer>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" @click="sendFile()">mdi-paperclip</v-icon>
                    </template>
                    <span>{{ fileUploadHintText }}</span>
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-card-text>
            <v-dialog v-if="dialog" v-model="dialog" max-width="400">
              <EnlargedImage
                v-if="dialog"
                :uuid="currentImageUuid"
                @close="((dialog = false), (currentImageUuid = null))"
            /></v-dialog>
          </v-card>
          <input ref="fileInput" type="file" style="display: none" :accept="acceptedFileTypes" @change="onFilePicked" />
        </v-responsive>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
/* eslint-disable no-debugger */

import API from '../../api';
import moment from 'moment';
import Socket from '@/sockets/socket';
import { formatName } from '@/util/stringUtils';
import axios from 'axios';
import EnlargedImage from '../image/EnlargedImage';
import notificationStore from '@/sockets/notificationStore';
import loginStore from '@/util/loginStore';
import {
  getAcceptedFileTypes,
  getMaxFileSizeBytes,
  getMaxFileSizeLabel,
  getUploadHintText,
  getFileKind
} from '@/util/uploadFileTypes';

export default {
  name: 'Profile',
  props: {
    username: {
      type: [String]
    }
  },
  components: {
    EnlargedImage
  },

  data: () => ({
    activeChat: 1,
    messages: [],
    message: '',
    name: '',
    error: '',
    userId: null,
    listener: null,
    chatId: null,
    pickedFileName: '',
    pickedFile: '',
    dialog: false,
    currentImageUuid: ''
  }),
  created: async function () {
    if (this.listener) {
      Socket.removeListener(this.listener);
    }
    this.listener = (type, payload) => {
      if (type === Socket.CHAT) {
        if (payload.chatId == this.chatId) {
          this.messages.push(payload);
          payload.new = true;
          Socket.sendSocketNotification(Socket.NOTIFICATIONS_READ, {
            parentObjectId: this.chatId,
            notificationType: Socket.CHAT
          });
          setTimeout(() => {
            var container = this.$el.querySelector('#container');
            container.scrollTop = container.scrollHeight;
          }, 100);
        }
      }
      if (type === Socket.CHAT_MESSAGE_DELETE) {
        this.deleteMessage(payload.uuid);
      }
    };
    Socket.addListener(this.listener);

    this.loadData(this.username);
    this.userId = loginStore.userId;
    if (this.userId) {
      this.userId = parseInt(this.userId);
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.loadData(to.params.username);
    next();
  },
  mounted() {
    document.title = 'Chat with:  ' + this.username;
  },
  beforeDestroy() {
    if (this.listener) {
      Socket.removeListener(this.listener);
    }
  },
  computed: {
    acceptedFileTypes() {
      return getAcceptedFileTypes('chat');
    },
    fileUploadHintText() {
      return getUploadHintText('chat');
    }
  },
  methods: {
    async loadData(username) {
      let res = await API.get('chat?username=' + encodeURI(username));
      if (!res) {
        return;
      }
      if (res.errors && res.errors.length > 0) {
        this.error = res.errors[0].msg;
      } else {
        this.error = null;
        this.name = formatName(res.data.name);
        this.chatId = res.data.chatId;
        let notificationKeys = {};
        for (let index = 0; index < notificationStore.notifications.length; index++) {
          const notification = notificationStore.notifications[index];
          if (notification.notificationType == 'chat') {
            notificationKeys[notification.objectId] = true;
          }
        }
        this.messages = res.data.messages;
        for (let index = 0; index < this.messages.length; index++) {
          const message = this.messages[index];
          if (notificationKeys[message.id]) {
            message.new = true;
          }
        }
        Socket.sendSocketNotification(Socket.NOTIFICATIONS_READ, {
          parentObjectId: this.chatId,
          notificationType: Socket.CHAT
        });
        setTimeout(() => {
          var container = this.$el.querySelector('#container');
          container.scrollTop = container.scrollHeight;
        }, 100);
      }
    },
    me(message) {
      return message.userId === this.userId;
    },
    // Returns 'image' | 'video' | 'pdf' | 'document' | 'audio' | 'archive' |
    // 'other' | null (no attachment at all). Drives which rendering the
    // template picks for a given message's attachment, if any.
    fileKind(msg) {
      if (!msg.fileUuid) return null;
      return getFileKind(msg.fileName || '');
    },
    fileIcon(msg) {
      const icons = {
        video: 'mdi-file-video',
        pdf: 'mdi-file-pdf-box',
        audio: 'mdi-file-music',
        archive: 'mdi-zip-box',
        document: 'mdi-file-document',
        other: 'mdi-file'
      };
      return icons[this.fileKind(msg)] || 'mdi-file';
    },
    // Non-image attachments don't get an inline preview — clicking the chip
    // fetches a fresh presigned URL (chat files are private) and lets the
    // browser handle opening/downloading it natively in a new tab.
    async openFile(msg) {
      try {
        let res = await API.get('/file/load?uuid=' + encodeURI(msg.fileUuid));
        let url = res && res.data && res.data.file ? res.data.file.url : null;
        if (url) {
          window.open(url, '_blank');
        } else {
          this.error = 'Could not open file';
        }
      } catch (err) {
        this.error = 'Could not open file';
      }
    },
    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        if (files[0].size > getMaxFileSizeBytes('chat')) {
          this.error = `File is too large. Max size is ${getMaxFileSizeLabel('chat')}.`;
          return;
        }
        this.pickedFile = files[0];
        this.pickedFileName = files[0].name;
        if (this.pickedFileName.lastIndexOf('.') <= 0) {
          return;
        }

        (async () => {
          try {
            // Step 1: ask the backend for a presigned S3 PUT url
            let presignedRes = await API.post('file/presigned-url', {
              fileType: 'chat',
              fileName: this.pickedFile.name,
              contentType: this.pickedFile.type || 'application/octet-stream',
              needsThumbnail: false
            });

            if (presignedRes.errors && presignedRes.errors.length > 0) {
              this.error = presignedRes.errors[0].msg;
              return;
            }

            let { uuid, key, presignedUrl } = presignedRes.data;

            // Step 2: upload directly to S3
            const s3Axios = axios.create();
            delete s3Axios.defaults.headers.common['Authorization'];
            await s3Axios.put(presignedUrl, this.pickedFile, {
              headers: {
                'Content-Type': this.pickedFile.type || 'application/octet-stream'
              }
            });

            // Step 3: confirm the upload so a UserFile row gets created
            let confirmRes = await API.post('file/confirm-upload', {
              uuid,
              key,
              fileName: this.pickedFile.name,
              fileType: 'chat'
            });

            if (confirmRes.errors && confirmRes.errors.length > 0) {
              this.error = confirmRes.errors[0].msg;
              return;
            }

            // Step 4: 'chat' is a private file type, so confirm-upload never
            // returns a usable url/thumbnailUrl (both come back null). Fetch
            // a short-lived presigned display URL just so the sender sees
            // their own attachment immediately. NOTE: this URL is not
            // durable — it expires (~120s). Every subsequent read of the
            // message list regenerates it server-side via
            // ChatHelper.attachFreshFileInfo, the same way
            // FileController.loadFile does for EnlargedImage.
            let loadRes = await API.get('/file/load?uuid=' + encodeURI(confirmRes.data.uuid));
            let displayUrl = loadRes && loadRes.data ? loadRes.data.file.url : null;

            await this.sendFileMessage({
              uuid: confirmRes.data.uuid,
              fileName: this.pickedFile.name,
              thumbnailUrl: displayUrl
            });
          } catch (err) {
            this.error = err.message || 'Upload failed';
          } finally {
            this.pickedFileName = '';
            this.pickedFile = '';
          }
        })();
      } else {
        this.pickedFileName = '';
        this.pickedFile = '';
      }
    },
    async sendFileMessage(file) {
      let res = await API.post('chat', {
        username: this.username,
        fileUuid: file.uuid,
        thumbnailUrl: file.thumbnailUrl
      });
      if (!res) {
        return;
      }
      if (res.errors && res.errors.length > 0) {
        this.error = res.errors[0].msg;
      } else {
        this.error = null;
        this.messages.push({
          text: this.message,
          userId: this.userId,
          fileUuid: file.uuid,
          // fileName isn't persisted on ChatMessages (no such column) — it's
          // only ever derived server-side from the UserFile row on read.
          // Kept here too so this message renders correctly immediately,
          // before the next reload re-derives it the same way.
          fileName: file.fileName,
          uuid: res.data.uuid,
          thumbnailUrl: file.thumbnailUrl,
          createdAt: new Date()
        });
        setTimeout(() => {
          var container = this.$el.querySelector('#container');
          container.scrollTop = container.scrollHeight;
        }, 100);
        this.message = '';
      }
    },
    async deleteMessageOrBlockUser(msg) {
      let res = await API.delete('chat', { uuid: msg.uuid });

      if (!res) {
        return;
      }
      if (res.errors && res.errors.length > 0) {
        this.error = res.errors[0].msg;
      } else {
        this.deleteMessage(msg.uuid);
      }
    },
    async sendMessage() {
      if (this.message != '') {
        let res = await API.post('chat', {
          username: this.username,
          text: this.message
        });
        if (!res) {
          return;
        }
        if (res.errors && res.errors.length > 0) {
          this.error = res.errors[0].msg;
        } else {
          this.error = null;
          this.messages.push({
            text: this.message,
            userId: this.userId,
            uuid: res.data.uuid,
            createdAt: new Date()
          });
          setTimeout(() => {
            var container = this.$el.querySelector('#container');
            container.scrollTop = container.scrollHeight;
          }, 100);
          this.message = '';
        }
      }
    },
    async deleteMessage(messageUuid) {
      let messages = [];
      for (let index = 0; index < this.messages.length; index++) {
        const message = this.messages[index];
        if (message.uuid !== messageUuid) {
          messages.push(message);
        }
      }
      this.messages = messages;
    },
    async sendFile() {
      this.$refs.fileInput.click();
    },
    formatDate(date) {
      return moment(date).format('LLL');
    },
    loadImage(uuid) {
      this.currentImageUuid = uuid;
      this.dialog = true;
    }
  }
};
</script>

<style>
.main-container {
  font-family: 'Nunito', sans-serif !important;
}
.avatar {
  width: 140px !important;
  height: 140px !important;
  top: -70px !important;
  left: 30px !important;
  border: 5px solid #fff;
}
.avatarMember {
  width: 140px !important;
  height: 140px !important;
  left: 30px !important;
  border: 5px solid #fff;
}
h1 {
  font-size: 15px;
  font-weight: 600;
  border-bottom: solid 2px #eee;
  padding-bottom: 4px;
  line-height: 22px;
}
.chat-file-chip {
  display: flex;
  align-items: center;
  gap: 6px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 6px;
  padding: 6px 10px;
  margin-bottom: 4px;
  cursor: pointer;
  max-width: 220px;
}
.chat-file-name {
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
